let googleMapsScriptLoadingPromise = null;

function loadGoogleMaps(language = "de") {
  if (googleMapsScriptLoadingPromise) {
    return googleMapsScriptLoadingPromise;
  }

  googleMapsScriptLoadingPromise = new Promise((resolve, reject) => {
    if (window.google && window.google.maps) {
      return resolve(window.google);
    }

    const existingScript = document.querySelector('script[src*="maps.googleapis.com/maps/api/js"]');
    if (existingScript) {
      existingScript.remove();
    }

    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyC_Jamr7BU0zLsUJFeliWVEEpFT5bNcU-c&language=${language}&libraries=places,geocoding`;
    script.async = true;
    script.defer = true;

    script.onload = () => {
      if (window.google && window.google.maps) {
        resolve(window.google);
      } else {
        reject(new Error("Google Maps loaded but window.google is undefined"));
      }
    };

    script.onerror = reject;

    document.body.appendChild(script);
  });

  return googleMapsScriptLoadingPromise;
}

export default loadGoogleMaps;
